<!-- @veltra/icons generated sha256:9a8aaf8aae19ce1e gen:8 source:src/svg/normal/wallet.svg -->
<script setup lang="ts">
defineOptions({ name: 'Wallet' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path
      fill="currentColor"
      d="M11.5 4.5h2a1 1 0 0 1 1 1V12a1 1 0 0 1-1 1h-11a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1zM9.99 3H3.01c-.277 0-.51.23-.51.506V4.5h8v-.994A.513.513 0 0 0 9.99 3m3.51 2.5h-11V12h11z"
    />
  </svg>
</template>
